exports.getGoodlookURL = () => (window.goodway.NODE_ENV === 'production' ? 'https://goodlook.goodwaygroup.com/' : 'https://goodlook.staging.goodwaygroup.com/');



// WEBPACK FOOTER //
// ./src/helpers/goodlook.js